import type { HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium tracking-wide whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'bg-surface-muted text-text-subtle border border-border',
        open: 'bg-status-open-tint text-status-open-on-tint',
        accepted: 'bg-status-accepted-tint text-status-accepted-on-tint',
        completed: 'bg-status-completed-tint text-status-completed-on-tint',
        cancelled: 'bg-status-cancelled-tint text-status-cancelled-on-tint',
        expired: 'bg-status-cancelled-tint text-status-cancelled-on-tint',
        urgent: 'bg-error-tint text-error-on-tint',
        brand: 'bg-brand-100 text-brand-900 dark:bg-brand-900/40 dark:text-brand-500',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
